import { FC } from 'react';

import { Box, IconButton, Tooltip } from '@chakra-ui/react';
import { VscFeedback } from 'react-icons/vsc';
import { useIntl } from 'react-intl';

interface FeedbackButtonProps {
    redirectUrl: string;
}

const FeedbackButton: FC<FeedbackButtonProps> = ({ redirectUrl }) => {
    const intl = useIntl();

    const buttonLabel = intl.formatMessage({
        id: 'nav.main.feedback.hover',
        defaultMessage: 'Event-Feedback'
    });

    return (
        <>
            <Box>
                <Tooltip label={buttonLabel} fontSize="md" hasArrow placement="left">
                    <IconButton
                        aria-label={buttonLabel}
                        icon={<VscFeedback />}
                        size="xl"
                        h="40px"
                        w="40px"
                        fontSize="2xl"
                        isRound={true}
                        colorScheme="brand"
                        variant="outline"
                        borderWidth="3px"
                        onClick={() => window.open(redirectUrl, '_blank')}
                    />
                </Tooltip>
            </Box>
        </>
    );
};

export default FeedbackButton;
